import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@chakra-ui/react";
import ParentProfile from "./ParentProfile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
  } from '@chakra-ui/react'

function RightParentSidebar({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);
    console.log(children)
  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth < 1200);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <div className={(isMobile) && 'fixed top-4 right-4 z-50' }>
      {!isMobile ? (
        <Box
          borderLeft="2px solid #F0F0F0" // Línea divisoria a la izquierda
          borderRight="2px solid #F0F0F0" // Línea divisoria a la derecha como en Sidebar
          maxW="400px"
        >
          <div className="py-4 sm:py-6 md:py-8 px-2 sm:px-4 h-screen flex flex-col">
            <div className="w-full md:flex justify-between items-center gap-2 perfil-section my-4">
              <ParentProfile />
            </div>
            <div className="w-full my-2 max-h-full overflow-y-auto">
              {children}
            </div>
          </div>
        </Box>
      ) : (
        <IconButton
          className="fixed top-4 right-4 z-50"
          size="md"
          colorScheme={"gray"}
          icon={<FontAwesomeIcon icon="fas fa-bars" />}
          onClick={() => setIsOpen(!isOpen)}
        />
      )}
      <Drawer
        isOpen={isOpen}
        placement='right'
        onClose={() => setIsOpen(false)}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <Box
          borderLeft="2px solid #F0F0F0" // Línea divisoria a la izquierda
          borderRight="2px solid #F0F0F0" // Línea divisoria a la derecha como en Sidebar
        >
          <div className="py-4 sm:py-6 md:py-8 px-2 sm:px-4 h-screen flex flex-col">
            <div className="w-full md:flex justify-between items-center gap-2 perfil-section my-4">
              <ParentProfile />
            </div>
            <div className="w-full my-2 max-h-full overflow-y-auto">
              {children}
            </div>
          </div>
        </Box>
        </DrawerContent>
      </Drawer>
    </div>
  );
}

export default RightParentSidebar;
